import { UserRepository } from 'application/repositories/UserRepository';
import {
    BeforeEkycPayload,
    BeforeEkycResponse,
    MFASettingPayload,
    MGUser,
    MemberCorpoPayload,
    MemberCorpoResult,
    MemberInfoResult,
    MyPageUserInfo,
    RegistStepOnePayload,
    RegistStepTwoPayload,
    UserInfo,
    UserInfoResult,
} from 'domain/entities/UserEntity';
import { commonHelpers } from 'utilities/helpers';

export class UserUseCase implements UserUseCaseInterface {
    private userRepo: UserRepository;
    constructor(userRepo: UserRepository) {
        this.userRepo = userRepo;
    }

    async registUserInfo(userInfo: UserInfo): Promise<any> {
        return this.userRepo.registUserInfo(userInfo);
    }

    async getInfoToRegist(): Promise<any> {
        return this.userRepo.getInfoToRegist();
    }

    async getUserList(): Promise<MGUser[]> {
        const results: MGUser[] = [];

        for (let i = 0; i < 10; i++) {
            const model: MGUser = {
                id: i + 1,
                username: '山田太郎' + 1,
                displayName: 'Taro' + 1,
                mail: 'taro.yamada＠**co.jp',
                companyName: '＊＊＊株式会社',
                authority: 'システム管理者（NRBX）',
                flag: true,
            };
            results.push(model);
        }
        return results;
    }
    async getMemberCorproInfo(): Promise<MemberCorpoResult> {
        return this.userRepo.getMemberCorproInfo();
    }

    async registMemberCorproInfo(payload: MemberCorpoPayload): Promise<any> {
        return this.userRepo.registMemberCorproInfo(payload);
    }

    async editMemberCorproInfo(payload: MemberCorpoPayload): Promise<any> {
        return this.userRepo.editMemberCorproInfo(payload);
    }

    async updateLoanConsul(): Promise<any> {
        return this.userRepo.updateLoanConsul();
    }
    async getUserInfo(): Promise<MemberInfoResult> {
        return await this.userRepo.getUserInfo();
    }

    async deleteAccount(): Promise<any> {
        return this.userRepo.deleteAccount();
    }

    async settingMFA(payload: MFASettingPayload): Promise<any> {
        return this.userRepo.settingMFA(payload);
    }
    async getUserBasicInfo(): Promise<UserInfoResult> {
        return this.userRepo.getUserBasicInfo();
    }
    async registBeforeEkyc(payload: BeforeEkycPayload): Promise<any> {
        return this.userRepo.registBeforeEkyc(payload);
    }

    async regsitUserStep1(payload: RegistStepOnePayload): Promise<any> {
        return this.userRepo.regsitUserStep1(payload);
    }

    async getDefaultInfo(): Promise<UserInfoResult> {
        return await this.userRepo.getDefaultInfo();
    }

    async regsitUserStep2(payload: RegistStepTwoPayload): Promise<any> {
        //convert payload to FormData
        const formData = commonHelpers.convertObjectToFormData(payload);
        return this.userRepo.regsitUserStep2(formData);
    }
    async updateUserBasicInfo(payload: MyPageUserInfo): Promise<any> {
        //convert payload to FormData
        const formData = commonHelpers.convertObjectToFormData(payload);
        return this.userRepo.updateUserBasicInfo(formData);
    }
    async startEkyc(payload: { memberAccountId: number }): Promise<any> {
        return this.userRepo.startEkyc(payload);
    }
    async getBeforeEkycInfo(): Promise<BeforeEkycResponse> {
        return this.userRepo.getBeforeEkycInfo();
    }
}
export interface UserUseCaseInterface {
    getUserList(): Promise<MGUser[]>;
    registUserInfo(userInfo: UserInfo): Promise<any>;
    getInfoToRegist(): Promise<any>;
    getMemberCorproInfo(): Promise<MemberCorpoResult>;
    registMemberCorproInfo(payload: MemberCorpoPayload): Promise<any>;
    editMemberCorproInfo(payload: MemberCorpoPayload): Promise<any>;
    updateLoanConsul(): Promise<any>;
    getUserInfo(): Promise<MemberInfoResult>;
    deleteAccount(): Promise<any>;
    settingMFA(payload: MFASettingPayload): Promise<any>;
    getUserBasicInfo(): Promise<UserInfoResult>;
    getBeforeEkycInfo(): Promise<BeforeEkycResponse>;
    getDefaultInfo(): Promise<UserInfoResult>;
    registBeforeEkyc(payload: BeforeEkycPayload): Promise<any>;
    regsitUserStep1(payload: RegistStepOnePayload): Promise<any>;
    regsitUserStep2(payload: RegistStepTwoPayload): Promise<any>;
    updateUserBasicInfo(payload: MyPageUserInfo): Promise<any>;
    startEkyc(payload: { memberAccountId: number }): Promise<any>;
}
